import { VoucherService } from './../../service/voucherService/voucher.service';
import { CatagoryService } from './../../service/catagoryService/catagory.service';
import { RestaurantService } from './../../service/restaurantManager/restaurant.service';
import { FileUpload } from './../../service/FileUpload/fileUpload';
import { FileUploadService } from './../../file-upload.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import * as _ from "lodash";

@Component({
  selector: 'app-edit-restaurant',
  templateUrl: './edit-restaurant.component.html',
  styleUrls: ['./edit-restaurant.component.scss']
})
export class EditRestaurantComponent implements OnInit {
  members:any;
  addForm:any;
  image="https://i.ibb.co/4774fvj/profileimg.png";
  msg1:string;currentUpload:any;
msg="enter valid";
delete1:boolean=false;

allSelected = false;
allSelected1 = false;

@ViewChild('mySel') skillSel: MatSelect;
@ViewChild('mySel1') skillSel1: MatSelect;

selectedFile:File=null;restaurantPath:string='Restaurant';
all:boolean=false;
credit:any="Credit";
debit:any="Debit";
catagories:any=[];voucher:any=[]
upi:any="UPI";id:any;enableSub:any;
    constructor(private route:Router,private voucherService:VoucherService,private activeRoute:ActivatedRoute, private ApiService:RestaurantService,private catagoryService:CatagoryService, private fb:FormBuilder,private UploadService:FileUploadService) {
      this.addForm={
        name: "",
        image: {url:'https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png'},

        status:true
      }
this.id=this.activeRoute.snapshot.paramMap.get('id');
this.getRestaurant();
this.getCatagories();this.getVoucher();
     }
     

  ngOnInit(): void {
  }
  enableSubctatgory(event)
  {
    console.log(event.value)
    this.enableSub=event.value[0]
    console.log(this.enableSub)
  }
  
  getCatagories()
  {
    this.catagoryService.getCatagories().then((res)=>
    {
      this.catagories=res
      console.log(res)
    })
  }
  getRestaurant()
  {
    this.ApiService.getRestaurantsDetail(this.id).then((res)=>
    {
      this.addForm=res
      console.log(res)
    })
  }
  offerChange(education1) {
   console.log(education1);
   this.addForm.offerCode=education1;
   console.log(this.addForm);
  }
  getVoucher()
  {
this.voucherService.getVoucher().then((res)=>
{
  this.voucher=res
  console.log(this.voucher)
})
  }
  showPreview(event:any)
  {
    if(event.target.files && event.target.files[0])
    {
      const reader=new FileReader();
        reader.onload=(e:any)=>this.addForm.image.url=e.target.result;
        reader.readAsDataURL(event.target.files[0]);
        this.selectedFile=event.target.files[0];
        console.log(this.selectedFile);
      this.detectFiles();
    }
    else
    {
      this.addForm.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
    }
  }
  detectFiles() {
    // this.deletePreviousFile();
    // this.addForm.image={'url':"https://i.ibb.co/4774fvj/profileimg.png"}
    // this.currentUpload=null;
    this.uploadSingle();
  } 
  uploadSingle()
  {
    this.currentUpload = new FileUpload(this.selectedFile);
    console.log(this.currentUpload);
    this.UploadService.pushUpload(this.currentUpload,this.restaurantPath).then((res) => {
      this.addForm.image = res;
      this.delete1=true
      this.currentUpload=null;
      console.log(this.addForm.image);
      console.log(this.UploadService.uploadPercentage);
    });
  }
  uploadMulti() {
    let files = this.selectedFile;
    let filesIndex = _.range(files.size);
    _.each(filesIndex, (idx) => {
      this.currentUpload = new FileUpload(files[idx]);
      this.UploadService.pushUpload(this.currentUpload, this.restaurantPath);
    });
  }

  delete()
  {
    this.deletePreviousFile();
    
  }
  deletePreviousFile()
  {
    if(this.addForm.image.name!=undefined)
    {
      this.UploadService.deleteUpload(this.addForm.image,this.restaurantPath).then((res)=>
      {
        console.log('Previous Image Deleted');
        this.addForm.image.url="https://www.linuxtrainingacademy.com/wp-content/plugins/all-in-one-seo-pack/images/default-user-image.png";
this.delete1=false
      })
    }
  }
  EditRestaurant()
  {
      
   this.ApiService.EditRestaurantsDetail(this.id,this.addForm).then(
      (res)=>
      {
        console.log(res);
        console.log("Restaurant is Updated");
        this.route.navigateByUrl('/dashboard/restaurantList')
      }
    );

  console.log(this.addForm);
    }


}
